import { render, staticRenderFns } from "./ColorCalibrationAfter.vue?vue&type=template&id=54b08e41&scoped=true&"
import script from "./ColorCalibrationAfter.vue?vue&type=script&lang=js&"
export * from "./ColorCalibrationAfter.vue?vue&type=script&lang=js&"
import style0 from "./ColorCalibrationAfter.vue?vue&type=style&index=0&id=54b08e41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b08e41",
  null
  
)

export default component.exports